const Financial = [
  {
    path: '/admin_control',
    name: 'SuperAdminControlRoutes',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Painel de super admin',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/super_admin_panel/SuperAdminPanel.vue`)
  },
  
]

export default Financial
